
import { APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'NewsSlider';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};



export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.$sliderIcons = this.$el.find('.js-slider-icons', this.$el);
        this.$wrapper = this.$el.find('.js-wrapper', this.$el);
    }

    init() {
        // Set events and such

        this.carousel = new Swiper(this.$el.find('.js-slider')[0], {
            speed: 400,
            grabCursor: true,
            mousewheel: false,
            loop: true,
            // If we need pagination
            pagination: {
                el: '.js-pagination',
                type: 'bullets',
                clickable: true
            }
        });

        this.imageCarousel = new Swiper(this.$el.find('.js-slider-images')[0], {
            speed: 400,
            grabCursor: true,
            mousewheel: false,
            loop: true
        });

        this.iconsCarousel = new Swiper(this.$el.find('.js-slider-icons')[0], {
            speed: 400,
            mousewheel: false,
            loop: true,
            allowTouchMove: false
        });

        this.carousel.controller.control = this.imageCarousel;
        this.imageCarousel.controller.control = this.carousel;

        if (this.carousel.slides[this.carousel.activeIndex].hasAttribute('data-color')) {
            const color = this.carousel.slides[this.carousel.activeIndex].getAttribute('data-color');

            this.$wrapper.css({
                'background-color': color
            });
            this.$sliderIcons.css({
                'color': color
            })

            this.carousel.on('transitionEnd', () => {
                this.$wrapper.css({
                    'background-color': color
                })
                this.$sliderIcons.css({
                    'color': color
                })
            });
        }

        this.carousel.on('slideChange', () => {
            this.iconsCarousel.slideTo(this.carousel.activeIndex,400);
        });

        this.$el.on(EVENT.CLICK, '.js-next',(e) => {
            this.carousel.slideNext();
        });

    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
